module.exports = __webpack_public_path__ + "static/media/hat-witch.203a773c.svg";